import './style.sass';

import { UserEmailData, UserResetPasswordData } from 'src/types/user';
import { EmailForm } from './EmailForm';
import { PasswordForm } from './PasswordForm';

type Props = {
    isEmailMode: boolean,
    onSubmit: (data: UserResetPasswordData | UserEmailData) => void;
};

export const ResetPasswordForm = ({ isEmailMode, onSubmit }: Props) => {
    return (
        <div className="reset-password-form">
            {isEmailMode
                ? <EmailForm onSubmit={onSubmit} />
                : <PasswordForm onSubmit={onSubmit}/>
            }
        </div>
    );
};

